
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getCountiesFromQuery",
      resolverType: "query",
      routePath: "/getCountiesFromQuery",
      httpMethod: "POST",
    });
  